/* eslint-disable no-restricted-imports */
import { useCallback, useState } from 'react';
import { showToastAsync } from '../../../../data-layer/notifications/actions';
import * as partnerService from '../../../../data-layer/partner/service';
import { FnsStatusEnum } from '../../../../data-layer/partner/types';
import { useDispatch } from '../../../../data-layer/useDispatch';
import { IconInfo } from '../../../icon/IconInfo';

interface UsePartnerSelfEmployedDialogParams {
    onRegistered: () => void;
}

export const usePartnerSelfEmployedDialog = ({
    onRegistered,
}: UsePartnerSelfEmployedDialogParams) => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();

    const handleCheck = useCallback(async () => {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        try {
            const { data } = await partnerService.getSignupExternalSelfEmployed();
            const isRegistered = data.fns_status !== FnsStatusEnum.UNREGISTERED;

            if (isRegistered) {
                onRegistered();
            } else {
                dispatch(
                    showToastAsync({
                        message: 'Не нашли такого самозанятого',
                        subtitle: 'Проверьте, всё ли верно',
                        icon: IconInfo,
                        color: 'invert',
                    }),
                );
            }
        } finally {
            setIsLoading(false);
        }
    }, [isLoading, onRegistered, dispatch]);

    return { isLoading, handleCheck };
};
